import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge v3 understands Tailwind v4's *leading* prefix syntax
 * (`tw:flex`). The prefix is declared without the separator — the library
 * appends the `:` itself — and any class that does not carry it is treated as
 * external and passed through untouched.
 */
const twMerge = extendTailwindMerge({ prefix: 'tw' });

/**
 * Merges Tailwind classes with conflict resolution.
 * Use for all conditional class merging in components.
 *
 * @example
 * cn('tw:flex tw:items-center', isActive && 'tw:bg-blue-primary')
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
